import React, { useState, useEffect } from 'react';
import logo from '../assets/Images/Clanbridge-logo.png2.png';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify'; 
import { generatePaymentAdvicePDF } from '../Components/Ragistration/AdviceGenerate/PaymentAdvicePDF';

const Paymentpage = () => {
  const [searchParams] = useSearchParams();
  const [longUrl, setLongUrl] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showExpiredPrompt, setShowExpiredPrompt] = useState(false);
  const [creatingNewLink, setCreatingNewLink] = useState(false);
  const [paymentData, setPaymentData] = useState(null);
  const UserId = sessionStorage.getItem("UserId");
  const token = searchParams.get('token');
  const [showSuccess, setShowSuccess] = useState(false);

  const authHeaders = {
    Authorization: `Bearer eyJhbGciOiJIUzI1NiJ9.eyJWYWxpZElzc3VlciI6IlByYXN5c3QiLCJWYWxpZEF1ZGllbmNlIjoiUHJhc3lzdCJ9.gMMGQ74cWLoymeDv0D4c3UQKTEJSCzdkXoxlW4qF5QU`,
    'Content-Type': 'application/json',
  };

  useEffect(() => {
    const processPayment = async () => {
      try {
        if (!token) {
          setError('Invalid payment token.');
          setLoading(false);
          return;
        }

        const instamojoResponse = await axios.post(
          `${process.env.REACT_APP_API_URL}PaymentGatewayLog/InstamojoLink`,
          { Trasid: token, Flag: '', TrjDocId: 0 },
          { headers: authHeaders }
        );

        if (instamojoResponse.data?.Status === 1) {
          setError(
            `⚠️ ${instamojoResponse.data?.Message || 'Payment data not found.'}`
          );
          setLoading(false);
          return;
        }

        const dataArray = instamojoResponse.data?.Data;
        if (!Array.isArray(dataArray) || dataArray.length === 0) {
          setError('⚠️ Payment data not found.');
          setLoading(false);
          return;
        }

        const data = dataArray[0];
        setPaymentData(data);

        const gateway = (data.Gatewaytype || '').toString();
        const url = data.longUrl || '';

        if (
          gateway.toLowerCase() === 'instamojo' ||
          url.includes('instamojo')
        ) {
          setShowExpiredPrompt(true);
          setLoading(false);
          return;
        }
        if (url) {
          setLongUrl(url);
        } else {
          setError('⚠️ No payment link available.');
        }
        setLoading(false);
      } catch (err) {
        console.error('Error:', err);
        setError('❌ Error fetching payment details. Please try again later.');
        setLoading(false);
      }
    };

    processPayment();
  }, [token]);

  const handleCreateNewLink = async () => {
    if (!paymentData) return;

    setCreatingNewLink(true);

    try {
      let existingCashFreeUrl = null;
      try {
        const logRes = await axios.post(
          `${process.env.REACT_APP_API_URL}PaymentGatewayLog/GetPaymentRequestLogDashBoard`,
          {
            pagenumber: 1,
            PageSize: 5,
            SearchText: paymentData.TrjDocId.toString(),
            PropId: paymentData.PropId || 0,
            SearchFrom: '2024-01-01',
            SearchTo: new Date().toISOString().split('T')[0],
            Flag: 'Url',
          },
          { headers: authHeaders }
        );

        const logs = logRes.data?.Data || [];
        const cfLog = logs.find(
          (l) =>
            l.Gatewaytype === 'CashFree' &&
            l.longUrl &&
            l.longUrl.includes('cashfree')
        );

        if (cfLog?.longUrl) existingCashFreeUrl = cfLog.longUrl;
      } catch (e) {
        console.warn('Log check failed:', e);
      }

      if (existingCashFreeUrl) {
        setLongUrl(existingCashFreeUrl);
        setShowExpiredPrompt(false);
        setCreatingNewLink(false);
        return;
      }

      const cashFreePayload = {
        customer_details: {
          customer_email: paymentData.Email || paymentData.email || '',
          customer_name:
            paymentData.ResidentName || paymentData.buyer_name || 'Resident',
          customer_phone: paymentData.phone,
        },
        link_amount: parseFloat(paymentData.amount) || 0,
        link_auto_reminders: true,
        link_currency: 'INR',
        link_expiry_time: '2026-06-09T15:04:05+05:30',
        link_id: `Testing9062026`,
        PropId: paymentData.PropId || 0,
        link_meta: {
          notify_url: `${process.env.REACT_APP_API_URL}CashFreepayment-success/`,
          return_url: `${process.env.REACT_APP_API_URL}CashFreepayment-success/`,
          upi_intent: false,
        },
        link_minimum_partial_amount: parseFloat(paymentData.amount) || 0,
        link_notes: {
          key_1: 'CashFreepay',
          key_2: 'fallbackFromExpiredInstamojo',
        },
        link_notify: {
          send_email: true,
          send_sms: true,
        },
        link_partial_payments: true,
        link_purpose:
          paymentData.purpose || `Payment # ${paymentData.TrjDocNo || ''}`,
        ResidentId: paymentData.ResidentId || 0,
        Flag: 'Active',
        Remark: 'Testing',
        TrjType: 'TrnPytAdv',
        TrjDocNo: paymentData.TrjDocNo,
        TrjDocId: paymentData.TrjDocId,
        cf_payment_id: '',
        payment_status: '',
      };

      const cfResponse = await axios.post(
        `${process.env.REACT_APP_API_URL}PaymentGatewayLog/CreateCashFreeLink`,
        cashFreePayload,
        { headers: authHeaders }
      );

      let cf = cfResponse.data;
      if (typeof cf === 'string') cf = JSON.parse(cf);

      if (!cf?.link_url) {
        setError(
          `⚠️ Failed to create payment link: ${
            cf?.message || cf?.Message || 'Unknown error'
          }`
        );
        setShowExpiredPrompt(false);
        return;
      }

      const cd = cf.customer_details || {};
      await axios.post(
        `${process.env.REACT_APP_API_URL}PaymentGatewayLog/InsertPaymentRequestLog`,
        {
          id: cf.link_id,
          cf_link_id: cf.cf_link_id,
          phone: cd.customer_phone || '',
          email: cd.customer_email || '',
          buyer_name: cd.customer_name || '',
          amount: cf.link_amount ?? cashFreePayload.link_amount,
          purpose: cf.link_purpose || cashFreePayload.link_purpose,
          status:
            (cf.link_status || '').toUpperCase() === 'ACTIVE'
              ? 'Active'
              : cf.link_status,
          send_sms: cashFreePayload.link_notify.send_sms,
          send_email: cashFreePayload.link_notify.send_email,
          longurl: cf.link_url,
          redirect_url:
            cf.link_meta?.return_url ||
            cashFreePayload.link_meta.return_url,
          link_qrcode: cf.link_qrcode || '',
          ResidentId: paymentData.ResidentId,
          TrjDocNo: paymentData.TrjDocNo,
          TrjDocId: paymentData.TrjDocId,
          TrjType: 'TrnPytAdv',
          Flag: 'Active',
          Remark: 'Re-created via CashFree',
          Gatewaytype: 'CashFree',
          link_amount_paid: cf.link_amount_paid ?? 0,
          link_expiry_time: cf.link_expiry_time,
          link_created_at: cf.link_created_at,
          created_at: cf.link_created_at,
        },
        { headers: authHeaders }
      );


      let monthNames = '';
    

      const pdfBase64 = await generatePaymentAdvicePDF({
        rowData: paymentData,
        pytAdvNo: paymentData.TrjDocNo,
        pytAdvDt: paymentData.PytAdvDt,
        propName: paymentData.PropName,
        residentName: paymentData.ResidentName,
        mobileNo: paymentData.MobileNo || paymentData.phone,
        email: paymentData.Email || paymentData.email,
        bookNo: paymentData.BookNo,
        balAmount: paymentData.amount,
        dueDt: paymentData.DueDt,
        monthNames: monthNames,
        paymentUrl: cf.link_url,
        logo: logo,
      });

      const baseUrl = window.location.origin;
      const paymentToken = cf.link_id;
      // const intermediatePageUrl = `${baseUrl}/paymentpage?token=${paymentToken}`;
      const emailPaymentUrl = cf.link_url;

      const userId = parseInt(sessionStorage.getItem('UserId')) || 0;

      const Subject = `Clanbridge Living - Payment Request For Payment Advice No. [${paymentData.TrjDocNo}]`;
      const Body = `Hey <strong>${paymentData.buyer_name}</strong>,<br><br>
      We would like to inform you that payment advice has been created for you tenancy at <strong>${paymentData.PropName}</strong>. Please find attached your payment advice with this email.<br><br>
      Following are the details : <br><br>
      Advice No: <strong>${paymentData.TrjDocNo}</strong><br>
      Amount: <strong>${paymentData.amount}</strong><br>
      Date Of Issue: <strong>${new Date().toLocaleDateString()}</strong><br>
      Due Date: <strong>${new Date().toLocaleDateString()}</strong><br>
      ${monthNames ? `Tenure: <strong>${monthNames.split(') , ')[0] + ')' || '-'}</strong><br>` : ''}
      ${monthNames ? `Rent of Months: <strong>${monthNames.split(') , ')[1] || '-'}</strong><br>` : ''}
      <strong>Payment Link:</strong> <a href="${emailPaymentUrl}" target="_blank" style="background-color: #1b29a7ff; color: white; padding: 4px 10px; text-decoration: none; border-radius: 4px; display: inline-block; margin-top: 5px;">Pay Now</a><br><br>
      We hope you are having a pleasant stay with us. Do let us know if you need any assistance. You may contact us at <strong>sales@clanbridge.com</strong> or reach out to Your Resident Captains.<br>
      Cheers,<br>
      Team Clanbridge`;

      const emailRequest = {
        ToEmail:
          paymentData.Email || paymentData.email
            ? [paymentData.Email || paymentData.email]
            : [],
        Subject,
        Body,
        PropId: paymentData.PropId,
        UserId: UserId || '1',
        ImgFolderNm: paymentData.TrjDocNo || 'PytAdvice',
        DocAttachments: [
          {
            FileName: `Payment_Advice_${paymentData.TrjDocNo}.pdf`,
            FileContent: `data:application/pdf;base64,${pdfBase64}`,
          },
        ],
        TblName: 'TrnPytAdv',
        Id: paymentData.TrjDocId,
      };

      const emailResponse = await axios.post(
        `${process.env.REACT_APP_API_URL}EmailRequest/SendEmail`,
        emailRequest,
        { headers: authHeaders }
      );

      if (emailResponse.data?.Status === 0) {
        toast.success(emailResponse.data.Message);
      } else {
        toast.info(emailResponse.data?.Message || 'Email not sent');
      }
      setShowSuccess(true);  
      setLongUrl(cf.link_url);
      setShowExpiredPrompt(false);
    } catch (err) {
      console.error('CashFree creation/email error:', err);
      setError('❌ Failed to create new payment link. Please try again.');
      setShowExpiredPrompt(false);
      setShowSuccess(false);  
    } finally {
      setCreatingNewLink(false);
    }
  };

  const handleProceed = () => {
    if (longUrl) {
      window.open(longUrl, '_blank');
    }
  };

  return (
    <div style={styles.wrapper}>
      <ToastContainer />
      <div style={styles.card}>
        <img src={logo} alt="Clanbridge Logo" style={styles.logo} />

        {loading && <p style={styles.message}>⏳ Checking payment status...</p>}

        {error && <p style={styles.error}>{error}</p>}

        {!loading && !error && showExpiredPrompt && (
          <>
            <h2 style={styles.expiredTitle}>Your payment link has expired.</h2>
            <p style={styles.expiredSubtitle}>
              Would you like a new payment link?
            </p>

            <button
              style={{
                ...styles.button,
                opacity: creatingNewLink ? 0.7 : 1,
                cursor: creatingNewLink ? 'not-allowed' : 'pointer',
              }}
              onClick={handleCreateNewLink}
              disabled={creatingNewLink}
            >
              {creatingNewLink ? '⏳ Creating...' : 'Create Payment Link'}
            </button>
          </>
        )}

        {!loading && !error && !showExpiredPrompt && longUrl && (
          <>
            <h2 style={styles.title}>You're Almost There!</h2>
            <p style={styles.subtitle}>
              Click the button below to proceed with your payment.
            </p>
            <div style={styles.successWrap}>
              <div style={styles.successCircle}>
                <span style={styles.successTick}>✓</span>
              </div>
              <h2 style={styles.successTitle}>Link Created Successfully!</h2>
              <p style={styles.successSubtitle}>
                Payment link has been sent to the resident's email.
              </p>
            </div>
            <button style={styles.button} onClick={handleProceed}>
              Proceed to Pay
            </button>
          </>
        )}
     
      </div>
    </div>
  );
};

const styles = {
  wrapper: {
    minHeight: '91vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#f2f4f8',
    padding: '20px',
  },
  card: {
    width: '100%',
    maxWidth: '450px',
    backgroundColor: '#fff',
    padding: '40px 30px',
    borderRadius: '10px',
    boxShadow: '0 6px 18px rgba(0,0,0,0.1)',
    textAlign: 'center',
    fontFamily: 'Arial, sans-serif',
  },
  logo: { width: '180px', marginBottom: '5px' },
  title: { fontSize: '24px', color: '#1b1b1b', marginBottom: '10px' },
  subtitle: {
    fontSize: '16px',
    color: '#555',
    marginBottom: '30px',
    lineHeight: 1.5,
  },
  expiredTitle: {
    fontSize: '22px',
    color: '#d32f2f',
    marginBottom: '12px',
    fontWeight: '600',
  },
  expiredSubtitle: {
    fontSize: '16px',
    color: '#555',
    marginBottom: '30px',
    lineHeight: 1.5,
  },
  message: { fontSize: '16px', color: '#555' },
  error: {
    color: '#d32f2f',
    fontWeight: 'bold',
    fontSize: '16px',
    marginTop: '10px',
  },
  button: {
    backgroundColor: '#1b29a7',
    color: 'white',
    padding: '14px 30px',
    fontSize: '16px',
    borderRadius: '6px',
    border: 'none',
    cursor: 'pointer',
    transition: 'background-color 0.3s',
    width: '100%',
  },
  successWrap: {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '10px 0',
},
successCircle: {
  width: '90px',
  height: '90px',
  borderRadius: '50%',
  backgroundColor: '#28a745',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: '20px',
  boxShadow: '0 6px 18px rgba(40, 167, 69, 0.35)',
  animation: 'pop 0.4s ease-out',
},
successTick: {
  color: '#fff',
  fontSize: '48px',
  fontWeight: 'bold',
  lineHeight: 1,
},
successTitle: {
  fontSize: '22px',
  color: '#1b1b1b',
  marginBottom: '8px',
  fontWeight: '600',
},
successSubtitle: {
  fontSize: '15px',
  color: '#555',
  lineHeight: 1.5,
},
};

styles.button[':hover'] = { backgroundColor: '#0f1c80' };

export default Paymentpage;